<template>
  <div class="made">
    <TabBar_m />
    <div class="banner"></div>
    <div class="title">
      <h6>Order process</h6>
      <i></i>
      <h3>定制流程</h3>
    </div>
    <div class="made_box">
      <div class="made_item">
        <div class="made_item_icon">
          <img src="../assets/image_m/made_1.png" alt />
        </div>
        <div class="made_item_num">
          <img src="../assets/image_m/1.png" alt />
        </div>
        <div class="made_item_txt">
          <h5>提交需求</h5>
          <p>填写表格的内容，与公司人员沟通需求。</p>
        </div>
      </div>
      <div class="made_item">
        <div class="made_item_icon">
          <img src="../assets/image_m/made_2.png" alt />
        </div>
        <div class="made_item_num">
          <img src="../assets/image_m/2.png" alt />
        </div>
        <div class="made_item_txt">
          <h5>策划</h5>
          <p>根据需求分析提供最专业的的策划服务。</p>
        </div>
      </div>
      <div class="made_item">
        <div class="made_item_icon">
          <img src="../assets/image_m/made_3.png" alt />
        </div>
        <div class="made_item_num">
          <img src="../assets/image_m/3.png" alt />
        </div>
        <div class="made_item_txt">
          <h5>立项</h5>
          <p>签订合同，支付预付款。</p>
        </div>
      </div>
      <div class="made_item">
        <div class="made_item_icon">
          <img src="../assets/image_m/made_4.png" alt />
        </div>
        <div class="made_item_num">
          <img src="../assets/image_m/4.png" alt />
        </div>
        <div class="made_item_txt">
          <h5>设计</h5>
          <p>根据需求进行交互图、设计图的制作。</p>
        </div>
      </div>
      <div class="made_item">
        <div class="made_item_icon">
          <img src="../assets/image_m/made_5.png" alt />
        </div>
        <div class="made_item_num">
          <img src="../assets/image_m/5.png" alt />
        </div>
        <div class="made_item_txt">
          <h5>开发</h5>
          <p>开发人员根据设计图进行前台和后台的开发。</p>
        </div>
      </div>
      <div class="made_item">
        <div class="made_item_icon">
          <img src="../assets/image_m/made_6.png" alt />
        </div>
        <div class="made_item_num">
          <img src="../assets/image_m/6.png" alt />
        </div>
        <div class="made_item_txt">
          <h5>测试</h5>
          <p>开发完成之后进行系统整体的测试。</p>
        </div>
      </div>
      <div class="made_item">
        <div class="made_item_icon">
          <img src="../assets/image_m/made_7.png" alt />
        </div>
        <div class="made_item_num">
          <img src="../assets/image_m/7.png" alt />
        </div>
        <div class="made_item_txt">
          <h5>验收</h5>
          <p>签订验收单，把所有东西交付给客户。</p>
        </div>
      </div>
    </div>

    <div class="personal_form">
      <div class="title">
        <h6>personalization</h6>
        <i></i>
        <h3>个性化定制</h3>
      </div>
      <form action>
        <input type="text" placeholder="请输入您目前的行业" />
        <input type="text" placeholder="请输入您关于智慧物联的预算是？" />
        <input type="text" placeholder="请输入您的姓名(我们承诺，绝不泄露个人隐私)" />
        <input type="text" placeholder="请输入您的联系电话" />
        <a href="javascript:;" class="submit">确认提交</a>
      </form>
    </div>
    <Footer_m />
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: {},
  created() {},
  mounted() {},
};
</script>
<style lang="less" scoped>
.banner {
  background: url("../assets/image_m/made_banner.png") no-repeat;
  background-position: center;
  background-size: 100%;
  margin-top: 50px;
  &::after {
    padding-top: 100%;
    content: "";
    display: block;
  }
}
.title {
  padding: 16px;
  h6 {
    line-height: 15px;
    font-size: 10px;
    text-transform: uppercase;
  }
  i {
    display: block;
    width: 30px;
    height: 2px;
    background: #26acff;
    margin: 4px 0;
  }
  h3 {
    line-height: 25px;
    font-size: 18px;
    margin-bottom: 12px;
  }
  p {
    text-indent: 2em;
    line-height: 21px;
    font-size: 15px;
  }
}
.made_box {
  padding: 0 13px;
  .made_item {
    display: flex;
    align-items: center;
    .made_item_icon {
      width: 80px;
      height: 80px;
      img {
        width: 100%;
      }
    }
    .made_item_num {
      width: 30px;
      height: 31px;
      img {
        width: 100%;
      }
    }
    .made_item_txt {
      margin-left: 4px;
      h5 {
        line-height: 40px;
        font-size: 15px;
      }
      p {
        line-height: 12px;
        font-size: 12px;
      }
    }
  }
}
.personal_form {
  background: url("../assets/image_m/made_8.png") no-repeat;
  background-position: center;
  background-size: 100%;
  padding: 0 16px 32px;
  margin-top: 47px;
  .title {
    color: #fff;
    i {
      background-color: #fff;
    }
  }
  form input {
    border-radius: 5px;
    background: #ffffff;
    height: 44px;
    width: 100%;
    border: 0;
    margin-bottom: 20px;
    padding-left: 10px;
    input::-webkit-input-placeholder {
      color: #999999;
    }
    input:-ms-input-placeholder {
      // IE10+
      color: #999999;
    }
    input:-moz-placeholder {
      // Firefox4-18
      color: #999999;
    }
    input::-moz-placeholder {
      // Firefox19+
      color: #999999;
    }
  }
  form .submit {
    margin: 0 auto;
    display: block;
    width: 230px;
    height: 44px;
    background: #26acff;
    box-shadow: 0px 3px 5px rgba(38, 172, 255, 0.3);
    border-radius: 22px;
    color: #fff;
    text-align: center;
    line-height: 44px;
  }
}
</style>